import axios from "axios";

export type GetBookingRatesReturn = {
    code: string,
    label: string
}[]

export const getBookingRates =  async (): Promise<GetBookingRatesReturn> => {
    const response = await axios.get('/booking/search/rates');
    return response.data;
};

